import { IDictionary, Industry, KeyDateKind } from '@ViewModels';
import { inject } from 'mobx-react';
import * as React from 'react';
import { IUserSessionComponentProps, UserSessionViewModelKey } from '../../../../../models/AppState';
import { SvgIcon } from '../SvgIcon';

interface IProps extends React.SVGProps<SVGSVGElement>, IUserSessionComponentProps {
	className?: string;
	fillColor?: string;
	kind?: KeyDateKind;
}

const Sizes: IDictionary<{ width: number | string; height: number | string }> = {
	[KeyDateKind.Anniversary]: {
		height: 14,
		width: 15,
	},
	[KeyDateKind.Turning65]: {
		height: 14,
		width: 13,
	},
	[KeyDateKind.Turning72]: {
		height: 14,
		width: 13,
	},
	[KeyDateKind.Turning73]: {
		height: 14,
		width: 13,
	},
	[KeyDateKind.TurningXX]: {
		height: 14,
		width: 13,
	},
	[KeyDateKind.TurningXX2]: {
		height: 14,
		width: 13,
	},
	[KeyDateKind.TurningXX3]: {
		height: 14,
		width: 13,
	},
	[KeyDateKind.TurningXX4]: {
		height: 14,
		width: 13,
	},
	[KeyDateKind.TurningXX5]: {
		height: 14,
		width: 13,
	},
	[KeyDateKind.Birthday]: {
		height: 14,
		width: 13,
	},
	[KeyDateKind.Renewal]: {
		height: 14,
		width: 13,
	},
	[KeyDateKind.FinancialReview]: {
		height: 14,
		width: 13,
	},
	[KeyDateKind.Unknown]: {
		height: 14,
		width: 14,
	},
	[KeyDateKind.Wedding]: {
		height: 14,
		width: 10,
	},
	[KeyDateKind.Custom1]: {
		height: 18,
		width: 18,
	},
	[KeyDateKind.Custom2]: {
		height: 18,
		width: 18,
	},
	[KeyDateKind.Custom3]: {
		height: 18,
		width: 18,
	},
	[KeyDateKind.Custom4]: {
		height: 18,
		width: 18,
	},
	[KeyDateKind.Custom5]: {
		height: 18,
		width: 18,
	},
	[KeyDateKind.Custom6]: {
		height: 18,
		width: 18,
	},
	[KeyDateKind.Custom7]: {
		height: 18,
		width: 18,
	},
	[KeyDateKind.Custom8]: {
		height: 18,
		width: 18,
	},
	[KeyDateKind.Custom9]: {
		height: 18,
		width: 18,
	},
	[KeyDateKind.Custom10]: {
		height: 18,
		width: 18,
	},
};

const KeyDateIconSfc: React.FC<IProps> = props => {
	const { className, kind, fillColor, userSession, ...restProps } = props;
	const fill = fillColor || '#C75DA6';

	const industry = !!userSession && !!userSession.account ? userSession.account.toJs().additionalInfo.industry : null;
	let content: JSX.Element = (
		<path
			fill={fill}
			fillRule='evenodd'
			d='M12.598,12.6 L1.4001,12.6 L1.4001,4.9 L12.5994,4.9 L12.598,12.6 Z M12.6001,2.1 L11.9001,2.1 L11.9001,0 L10.5001,0 L10.5001,3.5 L9.8001,3.5 L9.8001,2.1 L4.9001,2.1 L4.9001,0 L3.5001,0 L3.5001,3.5 L2.8001,3.5 L2.8001,2.1 L1.4001,2.1 C0.628,2.1 0.0001,2.7286 0.0001,3.5 L0.0001,12.6 C0.0001,13.3721 0.628,14 1.4001,14 L12.6001,14 C13.3722,14 14.0001,13.3721 14.0001,12.6 L14.0001,3.5 C14.0001,2.7286 13.3722,2.1 12.6001,2.1 L12.6001,2.1 Z'
		/>
	);

	switch (kind) {
		case KeyDateKind.Anniversary: {
			if (industry === Industry.RealEstate) {
				content = (
					<g fill={fill} fillRule='evenodd'>
						<path d='M12.4082637,13.0454545 L12.4082637,11.1363636 C12.9345364,11.1363636 13.3628091,11.5646364 13.3628091,12.0909091 C13.3628091,12.6171818 12.9345364,13.0454545 12.4082637,13.0454545 M12.4082637,10.1818182 L11.4537182,10.1818182 L11.4537182,14 L12.4082637,14 C13.4608091,14 14.3173546,13.1434545 14.3173546,12.0909091 C14.3173546,11.0383636 13.4608091,10.1818182 12.4082637,10.1818182' />
						<polygon points='9.226 10.182 8.272 10.182 8.272 14 10.658 14 10.658 13.045 9.226 13.045' />
						<path d='M6.36280911 12.5681818C6.36280911 12.8316364 6.14899092 13.0454545 5.88553638 13.0454545 5.62208183 13.0454545 5.40826365 12.8316364 5.40826365 12.5681818L5.40826365 11.6136364C5.40826365 11.3501818 5.62208183 11.1363636 5.88553638 11.1363636 6.14899092 11.1363636 6.36280911 11.3501818 6.36280911 11.6136364L6.36280911 12.5681818zM5.88553638 10.1818182C5.09644547 10.1818182 4.4537182 10.8245455 4.4537182 11.6136364L4.4537182 12.5681818C4.4537182 13.3572727 5.09644547 14 5.88553638 14 6.67462729 14 7.31735456 13.3572727 7.31735456 12.5681818L7.31735456 11.6136364C7.31735456 10.8245455 6.67462729 10.1818182 5.88553638 10.1818182L5.88553638 10.1818182zM.635536379 11.375C.635536379 12.033 1.1707182 12.5681818 1.8287182 12.5681818L2.30599092 12.5681818C2.43708183 12.5681818 2.54462729 12.6750909 2.54462729 12.8068182 2.54462729 12.9385455 2.43708183 13.0454545 2.30599092 13.0454545L.635536379 13.0454545.635536379 14 2.30599092 14C2.96399092 14 3.49917274 13.4648182 3.49917274 12.8068182 3.49917274 12.1488182 2.96399092 11.6136364 2.30599092 11.6136364L1.8287182 11.6136364C1.69699092 11.6136364 1.59008183 11.5067273 1.59008183 11.375 1.59008183 11.2432727 1.69699092 11.1363636 1.8287182 11.1363636L3.49917274 11.1363636 3.49917274 10.1818182 1.8287182 10.1818182C1.1707182 10.1818182.635536379 10.717.635536379 11.375M10.1809909 4.45454545C9.8297182 4.45454545 9.54462729 4.73963636 9.54462729 5.09090909L9.54462729 7.63636364 5.72644547 7.63636364 5.72644547 5.09090909C5.72644547 4.73963636 5.44135456 4.45454545 5.09008183 4.45454545L4.90108183 4.45454545 7.63553638 2.11081818 10.3699909 4.45454545 10.1809909 4.45454545zM12.6869909 5.31236364C12.7792637 5.06227273 12.7067182 4.781 12.5043546 4.60790909L8.04980911.789727273C7.81117274.584818182 7.45990002.584818182 7.22126365.789727273L2.7667182 4.60790909C2.56435456 4.781 2.49180911 5.06227273 2.58408183 5.31236364 2.67699092 5.56118182 2.91435456 5.72727273 3.18099092 5.72727273L4.4537182 5.72727273 4.4537182 8.27272727C4.4537182 8.624 4.73880911 8.90909091 5.09008183 8.90909091L10.1809909 8.90909091C10.5322637 8.90909091 10.8173546 8.624 10.8173546 8.27272727L10.8173546 5.72727273 12.0900818 5.72727273C12.3567182 5.72727273 12.5947182 5.56118182 12.6869909 5.31236364L12.6869909 5.31236364z' />
					</g>
				);
			}
			break;
		}
		case KeyDateKind.Turning72:
		case KeyDateKind.Turning73:
		case KeyDateKind.Turning65:
		case KeyDateKind.Birthday:
		case KeyDateKind.TurningXX:
		case KeyDateKind.TurningXX2:
		case KeyDateKind.TurningXX3:
		case KeyDateKind.TurningXX4:
		case KeyDateKind.TurningXX5: {
			content = (
				<path
					fill={fill}
					fillRule='evenodd'
					d='M10.4993 12.8333333L2.33263335 12.8333333C2.01121668 12.8333333 1.74930001 12.5714167 1.74930001 12.25L1.74930001 10.7584167C2.09405001 10.9596667 2.48896668 11.0833333 2.91596668 11.0833333 3.61188335 11.0833333 4.23838335 10.7770833 4.66596668 10.2923333 5.09355001 10.7770833 5.72005001 11.0833333 6.41596668 11.0833333 7.11188335 11.0833333 7.73838335 10.7770833 8.16596668 10.2923333 8.59355001 10.7770833 9.22005001 11.0833333 9.91596668 11.0833333 10.3429667 11.0833333 10.7378833 10.9596667 11.0826333 10.7584167L11.0826333 12.25C11.0826333 12.5714167 10.8207167 12.8333333 10.4993 12.8333333L10.4993 12.8333333zM11.0826333 8.75C11.0826333 9.39341667 10.5593833 9.91666667 9.91596668 9.91666667 9.27255001 9.91666667 8.74930001 9.39341667 8.74930001 8.75 8.74930001 8.428 8.48796668 8.16666667 8.16596668 8.16666667 7.84396668 8.16666667 7.58263335 8.428 7.58263335 8.75 7.58263335 9.39341667 7.05938335 9.91666667 6.41596668 9.91666667 5.77255001 9.91666667 5.24930001 9.39341667 5.24930001 8.75 5.24930001 8.428 4.98796668 8.16666667 4.66596668 8.16666667 4.34396668 8.16666667 4.08263335 8.428 4.08263335 8.75 4.08263335 9.39341667 3.55938335 9.91666667 2.91596668 9.91666667 2.27255001 9.91666667 1.74930001 9.39341667 1.74930001 8.75L1.74930001 7.58333333 11.0826333 7.58333333 11.0826333 8.75zM11.6659667 6.41666667L1.16596668 6.41666667C.843966681 6.41666667.582633347 6.678.582633347 7L.582633347 12.25C.582633347 13.2148333 1.36780001 14 2.33263335 14L10.4993 14C11.4641333 14 12.2493 13.2148333 12.2493 12.25L12.2493 7C12.2493 6.678 11.9879667 6.41666667 11.6659667 6.41666667L11.6659667 6.41666667zM10.4993 1.66454167C10.8353 2.230375 11.0779667 2.73845833 11.0826333 2.916375 11.0826333 3.238375 10.8207167 3.49970833 10.4993 3.49970833 10.1778833 3.49970833 9.91596668 3.238375 9.91596668 2.91695833 9.92063335 2.73904167 10.1633 2.23095833 10.4993 1.66454167M9.91596668 4.55904167L9.91596668 5.83304167 11.0826333 5.83304167 11.0826333 4.55904167C11.7598833 4.31754167 12.2493 3.675875 12.2493 2.916375 12.2493 2.170875 11.3608833.804708333 10.9793833.251708333 10.7618-.063875 10.2368-.063875 10.0192167.251708333 9.63713335.804708333 8.74930001 2.170875 8.74930001 2.916375 8.74930001 3.675875 9.23813335 4.31754167 9.91596668 4.55904167M2.33263335 1.66454167C2.66863335 2.230375 2.91130001 2.73845833 2.91596668 2.916375 2.91596668 3.238375 2.65405001 3.49970833 2.33263335 3.49970833 2.01121668 3.49970833 1.74930001 3.238375 1.74930001 2.91695833 1.75396668 2.73904167 1.99663335 2.23095833 2.33263335 1.66454167M1.74930001 4.55904167L1.74930001 5.83304167 2.91596668 5.83304167 2.91596668 4.55904167C3.59321668 4.31754167 4.08263335 3.675875 4.08263335 2.916375 4.08263335 2.170875 3.19421668.804708333 2.81271668.251708333 2.59513335-.063875 2.07013335-.063875 1.85255001.251708333 1.47046668.804708333.582633347 2.170875.582633347 2.916375.582633347 3.675875 1.07146668 4.31754167 1.74930001 4.55904167M6.41596668 1.66454167C6.75196668 2.230375 6.99463335 2.73845833 6.99930001 2.916375 6.99930001 3.238375 6.73738335 3.49970833 6.41596668 3.49970833 6.09455001 3.49970833 5.83263335 3.238375 5.83263335 2.91695833 5.83730001 2.73904167 6.07996668 2.23095833 6.41596668 1.66454167M5.83263335 4.55904167L5.83263335 5.83304167 6.99930001 5.83304167 6.99930001 4.55904167C7.67655001 4.31754167 8.16596668 3.675875 8.16596668 2.916375 8.16596668 2.170875 7.27755001.804708333 6.89605001.251708333 6.67846668-.063875 6.15346668-.063875 5.93588335.251708333 5.55380001.804708333 4.66596668 2.170875 4.66596668 2.916375 4.66596668 3.675875 5.15480001 4.31754167 5.83263335 4.55904167'
				/>
			);
			break;
		}
		case KeyDateKind.FinancialReview:
		case KeyDateKind.Renewal: {
			content = (
				<g fill={fill} fillRule='evenodd'>
					<path d='M4.13426668,4.02406667 C4.52360002,4.36206667 4.57693335,4.9594 4.22893335,5.3614 C3.90026668,5.7394 3.27226668,5.78406667 2.89360002,5.45473333 C2.57360002,5.1774 2.22226668,4.2774 1.96960002,3.42206667 C2.96026668,3.58606667 3.90226668,3.82273333 4.13426668,4.02406667 M3.51360002,7.02006667 C4.17493335,7.02006667 4.80226668,6.73406667 5.23560002,6.23473333 C5.63493335,5.7754 5.83160002,5.1874 5.78826668,4.5794 C5.74560002,3.97206667 5.46826668,3.4174 5.00893335,3.0174 C4.12560002,2.25073333 1.30093335,1.97873333 0.229600016,1.8594 C0.373600016,2.52606667 0.927600016,5.5134 2.01960002,6.46206667 C2.43426668,6.8214 2.96493335,7.02006667 3.51360002,7.02006667' />
					<path d='M8.10693335,3.0264 C8.48026668,2.64306667 9.66293335,2.2684 10.7302667,2.0284 C10.4682667,3.23173333 10.1069333,4.41373333 9.82760002,4.7004 C9.36160002,5.17906667 8.60160002,5.18373333 8.12960002,4.72373333 C7.65560002,4.26173333 7.64560002,3.5004 8.10693335,3.0264 L8.10693335,3.0264 Z M8.85226668,12.6664 L4.47960002,12.6664 L3.59093335,9.99973333 L9.74093335,9.99973333 L8.85226668,12.6664 Z M7.54360002,5.95506667 C7.96093335,6.2404 8.45226668,6.39706667 8.96693335,6.39706667 C9.65693335,6.39706667 10.3016,6.1244 10.7829333,5.6304 C11.6882667,4.70173333 12.1842667,1.5664 12.3836,0.385733333 C11.7169333,0.4904 8.28426668,0.933066667 7.15160002,2.09573333 C6.67960002,2.58106667 6.42493335,3.2204 6.43360002,3.89706667 C6.43893335,4.2404 6.51160002,4.57106667 6.64493335,4.87573333 C6.23626668,5.4604 5.99893335,6.10773333 5.99893335,6.71373333 L5.99893335,8.6664 L2.66560002,8.6664 C2.45160002,8.6664 2.25026668,8.76973333 2.12493335,8.94373333 C1.99960002,9.11773333 1.96560002,9.34106667 2.03360002,9.5444 L3.36693335,13.5444 C3.45760002,13.8164 3.71226668,13.9997333 3.99893335,13.9997333 L9.33226668,13.9997333 C9.61960002,13.9997333 9.87426668,13.8164 9.96493335,13.5444 L11.2982667,9.5444 C11.3662667,9.34106667 11.3316,9.11773333 11.2062667,8.94373333 C11.0809333,8.76973333 10.8802667,8.6664 10.6656,8.6664 L7.33226668,8.6664 L7.33226668,6.71373333 C7.33226668,6.4784 7.41160002,6.2164 7.54360002,5.95506667 L7.54360002,5.95506667 Z' />
				</g>
			);
			break;
		}
		case KeyDateKind.Wedding: {
			content = (
				<g fill='#C75DA6' fillRule='evenodd'>
					<path d='M8.02266668,4.86 L7.17466668,5.892 C8.07200002,6.49 8.66600002,7.51 8.66600002,8.66666667 C8.66600002,10.5053333 7.17066668,12.0006667 5.33266668,12.0006667 C3.49466668,12.0006667 1.99933335,10.5053333 1.99933335,8.66666667 C1.99933335,7.51 2.59266668,6.49 3.49066668,5.892 L2.64266668,4.86 C1.44866668,5.706 0.666000016,7.096 0.666000016,8.66666667 C0.666000016,11.24 2.75933335,13.334 5.33266668,13.334 C7.90600002,13.334 9.99933335,11.24 9.99933335,8.66666667 C9.99933335,7.096 9.21666668,5.706 8.02266668,4.86' />
					<path d='M4.27526668,1.33333333 L6.38993335,1.33333333 L7.10593335,2.05 L5.33260002,4.266 L3.55926668,2.05 L4.27526668,1.33333333 Z M4.81193335,5.75 C4.93860002,5.908 5.12993335,6 5.33260002,6 C5.53526668,6 5.72660002,5.908 5.85326668,5.75 L8.51993335,2.41666667 C8.73193335,2.15133333 8.71060002,1.76866667 8.47060002,1.52866667 L7.13726668,0.195333333 C7.01193335,0.0706666667 6.84260002,0 6.66593335,0 L3.99926668,0 C3.82260002,0 3.65260002,0.0706666667 3.52793335,0.195333333 L2.19460002,1.52866667 C1.95393335,1.76866667 1.93326668,2.15133333 2.14526668,2.41666667 L4.81193335,5.75 Z' />
				</g>
			);
			break;
		}
		case KeyDateKind.Custom1:
		case KeyDateKind.Custom2:
		case KeyDateKind.Custom3:
		case KeyDateKind.Custom4:
		case KeyDateKind.Custom5: {
			content = (
				<path
					fill='#5B8B7F'
					fillRule='evenodd'
					d='M14.3977,14.4 L1.6001,14.4 L1.6001,5.6 L14.3993,5.6 L14.3977,14.4 Z M14.4001,2.4 L13.6001,2.4 L13.6001,0 L12.0001,0 L12.0001,4 L11.2001,4 L11.2001,2.4 L5.6001,2.4 L5.6001,0 L4.0001,0 L4.0001,4 L3.2001,4 L3.2001,2.4 L1.6001,2.4 C0.7177,2.4 0.0001,3.1184 0.0001,4 L0.0001,14.4 C0.0001,15.2824 0.7177,16 1.6001,16 L14.4001,16 C15.2825,16 16.0001,15.2824 16.0001,14.4 L16.0001,4 C16.0001,3.1184 15.2825,2.4 14.4001,2.4 L14.4001,2.4 Z'
					opacity='1'
				/>
			);
			break;
		}
		default: {
			break;
		}
	}

	return (
		<SvgIcon {...restProps} className={`key-date-icon ${className || ''}`} {...Sizes[kind || KeyDateKind.Unknown]}>
			{content}
		</SvgIcon>
	);
};

export const KeyDateIcon = inject(UserSessionViewModelKey)(KeyDateIconSfc);
